import React, {Component} from 'react';
import TipModal from "../../components/modal/TipModal";
import TipResponseModal from "../../components/modal/TipResponseModal";
import {connect} from "react-redux";
import * as actions from "../../actions";
import tip_util from "../../util/tip/util";
import {getMoneyBloxCurrentWalletBalance, getMoneyBloxWalletUserSessionDetails} from "../../assets/libs/MoneyBlox";

class LikeContainer extends Component {

    constructor() {
        super();
        this.state = {
            tipMessage: null,
            wallet_balance: "0.00",
        }
    }

    componentDidMount() {
        this.setState({
            wallet_balance: this.props.moneyblox.wallet_balance,
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.showTipModalFlag !== this.props.showTipModalFlag) {
            this.updateWalletBalance();
        }
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        tip_util.handleAPIResponse(nextProps, (message) => {
            this.setState({
                tipMessage: message
            }, () => {
                this.updateWalletBalance();
            })
        }, () => {

        });
    }


    getValueOfQueryParam = (objProps) => {
        try {
            let objProp = objProps ? objProps : this.props;
            return objProp.match.params.id.toString();
        } catch (e) {
            return -1;
        }
    };

    getType = () => {
        const pathname = this.props.location.pathname;
        if (pathname.indexOf("picture") >= 0) {
            return "picture";
        } else if (pathname.indexOf("video") >= 0) {
            return "video";
        } else if (pathname.indexOf("gallery") >= 0) {
            return "gallery";
        }
    };

    tipRequest = (tipAmount, screen) => {
        const uuid = this.getValueOfQueryParam()
        const type = this.getType();
        const broadcaster_id = this.props.content.broadcaster.id;
        tip_util.tipRequestFromClipStore(this.props, tipAmount, `${broadcaster_id}`, "clipstore", `${type}`, `${uuid}`, null, () => {
            this.updateWalletBalance();
        })
    };

    updateWalletBalance = () => {
        getMoneyBloxCurrentWalletBalance((wallet_balance) => {
            this.setState({
                wallet_balance: wallet_balance,
            });

            this.props.setWalletBalance(wallet_balance);
        });

        //this updates the redux state
        getMoneyBloxWalletUserSessionDetails(this.props);
    };

    render() {
        return (
            <div>
                {
                    this.props.showTipModalFlag && (
                        <TipModal
                            showTipModalFlag={this.props.showTipModalFlag}
                            hideTipModal={this.props.hideTipModal}
                            balance={this.state.wallet_balance}
                            addBalance={this.props.showMoneyBloxModal}
                            tipRequest={this.tipRequest}
                        />
                    )}
                {
                    this.state.tipMessage &&
                    <TipResponseModal
                        showTipResponseModalFlag={this.props.showTipResponseModalFlag}
                        hideTipResponseModal={this.props.hideTipResponseModal}
                        tipMessage={this.state.tipMessage}
                    />
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        showTipModalFlag: state.flag.showTipModalFlag,
        showTipResponseModalFlag: state.flag.showTipResponseModalFlag,
        moneyblox: state.moneyblox,
        commonConfirmationFlag: state.flag.commonConfirmationFlag,
        tip: state.tip,
    };
}

export default connect(mapStateToProps, actions)(LikeContainer);

